/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function FarseerFileRepresentationFromJSON(json) {
    return FarseerFileRepresentationFromJSONTyped(json, false);
}
export function FarseerFileRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        type: json['type'],
        category: json['category'],
        size: json['size'],
    };
}
export function FarseerFileRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        type: value.type,
        category: value.category,
        size: value.size,
    };
}
